import React, { Fragment } from 'react'
// import Loadable from 'react-loadable'
import { CommonModal } from 'sb-modal'

/*

Copy and use code below. We should use it until we move all files with Loadable to .ts and react-loadable-ts-transformer be added.
https://github.com/stushurik/react-loadable-ts-transformer

const ModalName = Loadable({
  loader: () => import('./ModalName/ModalName'),
  webpack: () => [ require.resolveWeak('./ModalName/ModalName') ],
  modules: [ './ModalName/ModalName' ],
})

 */

import ErrorModal from 'compositions/modals/ErrorModal/ErrorModal'
import SomethingWentWrongModal from 'compositions/modals/SomethingWentWrongModal/SomethingWentWrongModal'
import AlertModal from 'compositions/modals/AlertModal/AlertModal'
import { ReviewModal, ReviewTagsModal, ReviewThankYouModal, ReviewLatestScentModal } from 'compositions/modals/review'
import { ChangeFrequencyModal, ChangeFrequencyFeedbackModal } from 'compositions/modals/changeFrequency'
import ResubscribeConfirmationModal from 'compositions/modals/ResubscribeConfirmationModal/ResubscribeConfirmationModal'
import EmptyQueueRecommendationsModal from 'compositions/modals/EmptyQueueRecommendationsModal/EmptyQueueRecommendationsModal'


const Modals = () => (
  <Fragment>
    <CommonModal />
    <ErrorModal />
    <SomethingWentWrongModal />
    <AlertModal />
    <ReviewModal />
    <ReviewTagsModal />
    <ReviewThankYouModal />
    <ReviewLatestScentModal />
    <ChangeFrequencyModal />
    <ChangeFrequencyFeedbackModal />
    <ResubscribeConfirmationModal />
    <EmptyQueueRecommendationsModal />
  </Fragment>
)


export default Modals
